import Vue from 'vue'
import Vuex from 'vuex'
import store from './vuex/store.js';
Vue.use(Vuex)
import App from './App.vue'
import router from './router/index'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import 'jquery'
import 'popper.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import './common/font/font.css'
import './common/font/fontBold.css'

Vue.config.productionTip = false
Vue.prototype.$store = store;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
